export default "__VITE_ASSET__Begobm21__"